"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value, payCycle) {
  return value * 12 / payCycle;
};
//# sourceMappingURL=getPrice.js.map


//////////////////
// WEBPACK FOOTER
// ../benefit-price/lib/getPrice.js
// module id = 672
// module chunks = 0